<template>
  <!-- Modal -->
  <div class="modal it-dialog-scrollable fade" tabindex="-1" role="dialog" id="modalsearch">
    <div class="modal-dialog modal-dialog-right" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Cerca tra le Sentenze e le Ordinanze della Corte Costituzionale
              </h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                <svg class="icon">
                    <use :xlink:href="icons.itClose"></use>
                </svg>
              </button>
          </div>
          <div class="modal-body">
            <SearchForm ref="searchForm"/>
          </div>
          <div class="modal-footer">
              <button
                class="btn btn-outline-primary btn-sm float-left"
                type="button"
                @click="deleteFilters()">Cancella tutti i filtri</button>
              <button
                class="btn btn-primary btn-sm"
                type="button"
                data-dismiss="modal"
                @click="filterPronunce()">Cerca</button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import SearchForm from '@/components/layout/accessory/SearchForm';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'modal-search',
  components: {
    SearchForm,
  },
  methods: {
    deleteFilters() {
      this.$refs.searchForm.filters.years = [];
      this.$refs.searchForm.filters.presidents = [];
      this.$refs.searchForm.filters.relators = [];
      this.$refs.searchForm.$refs.yearsRange.setValue(['1956', '2019']);
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(() => {
        this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(() => {
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentSentenze,
            size: this.documentsSetsSize,
            type: 'sentenza',
          });
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentOrdinanze,
            size: this.documentsSetsSize,
            type: 'ordinanza',
          });
        });
      });
    },
    filterPronunce() {
      const searchFormFilters = this.$refs.searchForm.filters;
      if (
        searchFormFilters.years.length ||
        searchFormFilters.numbers.length ||
        searchFormFilters.ecli.length ||
        searchFormFilters.presidents.length ||
        searchFormFilters.relators.length ||
        searchFormFilters.judges.length) {
        this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(() => {
          this.$store.dispatch('SAVE_PRONUNCE_FILTER', {
            filters: {
              years: searchFormFilters.years,
              presidents: searchFormFilters.presidents,
              relators: searchFormFilters.relators,
              // judges: searchFormFilters.judges,
            },
          }).then(() => {
            this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(() => {
              this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
                start: this.documentsSetsStartFromDocumentSentenze,
                size: this.documentsSetsSize,
                type: 'sentenza',
              });
              this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
                start: this.documentsSetsStartFromDocumentOrdinanze,
                size: this.documentsSetsSize,
                type: 'ordinanza',
              });
              this.$router.push({ path: '/pronunce' });
            });
          });
        });
      }
    },
  },
  data() {
    return {
      icons: {
        itClose: `${sprites}#it-close`,
      },
    };
  },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/ModalSearch.vue